export const supportRequestsConstants = {
    ADD_SUPPORT_REQUEST_REQUEST: '[Support Requests] Add request',
    ADD_SUPPORT_REQUEST_FAILURE: '[Support Requests] Add failure',
    ADD_SUPPORT_REQUEST_DONE: '[Support Requests] Add done',
}
